import { Helmet } from 'react-helmet-async';
import { BASE_URL, PAGE_SEO } from '../seo/seoConfig';

const SEOHead = ({ pageKey }) => {
  const config = PAGE_SEO[pageKey];
  if (!config) return null;

  const canonicalUrl = `${BASE_URL}${config.canonicalPath}`;

  return (
    <Helmet>
      <title>{config.title}</title>
      <meta name="description" content={config.description} />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:title" content={config.title} />
      <meta property="og:description" content={config.description} />
      <meta property="og:image" content={config.ogImage} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content={config.ogType} />

      <meta name="twitter:card" content={config.twitterCard} />
      <meta name="twitter:title" content={config.title} />
      <meta name="twitter:description" content={config.description} />
      <meta name="twitter:image" content={config.ogImage} />
    </Helmet>
  );
};

export default SEOHead;
